<template>
    <div>
        <content-block title="产品编号" v-if="extra.isDirectDeal && this.id">
            {{this.id}}
        </content-block>
        <content-block title="商家产品编号" isRequired v-if="extra.isDirectDeal">
            <div class="col-sm-8" style="padding-left: 0">
                <v-input v-va.tab1="'required'"
                         type="text"
                         :class="{'input': true, 'is-danger': validateErrors.has('tab1', 'model.partnerDealId') }"
                         v-model="model.partnerDealId"
                         name="partnerDealId"
                         placeholder="请填写商家产品编号"
                         :disabled="!extra.isNew"/>
                <span v-show="validateErrors.has('tab1', 'model.partnerDealId')" class="help is-danger">请填写商家产品编号</span>
            </div>
            <div class="col-sm-4">
                <span v-if="extra.isNew"><span class="icon-error help-icon"></span> 产品保存后无法修改，请在上单前与商家确认</span>
                <span v-else><span class="icon-error help-icon"></span> 商家产品编号在产品保存后不可更改</span>
            </div>
        </content-block>
        <content-block title="对应合同" v-if="extra.isBD">
            {{extra.contractNum}}
        </content-block>
        <content-block title="对应合同" v-else isRequired>
            <div class="row">
                <v-select v-va.tab1="'required'"
                          :class="{'input': true, 'is-danger': validateErrors.has('tab1','model.contractId') }"
                          v-model="model.contractId"
                          placeholder="请选择合同"
                          class="col-sm-4"
                >
                    <v-option v-for="item in contractsList"
                              :label="item.contractName"
                              :value="item.id"
                              :key="item.id"
                    >
                    </v-option>
                </v-select>
                <div v-if="bankInfo && bankInfo.length > 0" class="col-sm-7">{{bankInfo}}</div>
            </div>
            <span v-show="validateErrors.has('tab1','model.contractId')" class="help is-danger">请选择合同</span>
        </content-block>
    </div>
</template>
<script>
    import { getContractsList, getContractsList4BD } from 'api/ticket'
    import ContentBlock from 'components/content-block/index.vue'
    import { mapActions, mapGetters } from 'vuex'
    export default {
        components: {
            ContentBlock
        },
        data () {
            return {
                bankInfo:'',
                contractsList: []
            }
        },
        methods: {
            ...mapActions(['login', 'getUser']),
            ...mapGetters(['user']),
        },
        props: {
            model: {
                type: Object,
                required: true
            },
            extra: {
                type: Object,
                required: true
            },
            updateServicePhone: {
                type: Function,
            },
            mode: {
                type: String,
                required: true
            },
            errors: {
                type: Array,
                required: true
            }
        },
        computed: {
            id: function() {
                return this.$route.params.id || null
            }
        },
        watch: {
            'model.contractId': function () {
                for (let i = 0; i < this.contractsList.length; i++) {
                    if (this.contractsList[i].id === this.model.contractId) {
                        this.bankInfo = `款项将打入此帐号：${this.contractsList[i].contractBank.otherBranchName} ${this.contractsList[i].contractBank.accountNum}`
                        if (this.contractsList[i].servicePhone.length > 0) {
                            this.servicePhone = JSON.parse(this.contractsList[i].servicePhone)
                            this.updateServicePhone(this.servicePhone)
                            if (this.servicePhone && this.servicePhone.length > 0 && (!this.extra.isBD || this.model.servicePhones[0].phone === '')) {
                                this.$set(this.model.servicePhones, 0, Object.assign({}, this.servicePhone[0]))
                            }
                        }
                        this.model.contractNum = this.contractsList[i].contractNum;
                    }
                }
            }
        },
        async mounted () {
            // 获取合同列表
            let supplierId = this.extra.supplierId
            if (!supplierId) {
                const userinfo = await this.getUser()
                supplierId = userinfo.supplierId
            }
            try {
                let res;
                if (this.extra.isBD) {
                    res = await getContractsList4BD(supplierId)
                } else {
                    res = await getContractsList(supplierId)
                }
                if (res.data) {
                    const contractList = res.data
                    this.contractsList = contractList.map((contractItem) => {
                        const obj = {}
                        Object.assign(obj, contractItem.contractDO, { contractBank: contractItem.contractBank })
                        return obj
                    })
                    // 直连有些老的单子，contractid是0
                    if (this.extra.isDirectDeal) {
                        if ((this.model.contractId === 0 || this.model.contractId === null) && this.model.contractNum !== '') {
                            for (let contract of this.contractsList) {
                                if (this.model.contractNum === contract.contractNum) {
                                    this.model.contractId = contract.id
                                }
                            }
                        }
                    }
                }
            } catch (e) {
                this.$message({
                    showClose: true,
                    message: e.message || '获取合同列表失败',
                    type: 'error',
                    duration: 10000
                })
            }
        }
    }
</script>
<style>
    .help-icon {
        font-size: 14px;
        color: #ff9d3c;
    }
</style>



// WEBPACK FOOTER //
// dealAndContract.vue?5e9fe1b5